import { configApiRef, featureFlagsApiRef, useApiHolder } from '@backstage/core-plugin-api';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { ChangeEvent } from 'react';
import { GithubOrigin } from '../../services/unifiedGithubService/unifiedGithubService.types';

const orgFromUrl = (url: string | undefined): string =>
  url
    ?.replace(/\/\*\*$/, '')
    .split('/')
    .filter(Boolean)
    .pop() ?? '';

export const GithubOrgPrefix = ({
  organization,
  selectable = false,
  onOrganizationChange,
}: {
  organization: string;
  selectable?: boolean;
  onOrganizationChange?: (organization: string, origin: GithubOrigin) => void;
}) => {
  const apiHolder = useApiHolder();
  const configApi = apiHolder.get(configApiRef);
  const featureFlagsApi = apiHolder.get(featureFlagsApiRef);
  const isEmuEnabled = featureFlagsApi?.isActive('github-emu-auth') ?? false;
  const emuOrg = isEmuEnabled ? orgFromUrl(configApi?.getOptionalString('catalog.emuOrgUrl')) : '';
  const isEmuOrganization = Boolean(emuOrg && organization === emuOrg);
  const accessibleName = `GitHub organization: ${organization}${isEmuOrganization ? ' (EMU)' : ''}`;
  const handleOrganizationChange = (event: ChangeEvent<{ value: unknown }>) => {
    const selectedOrganization = String(event.target.value);
    onOrganizationChange?.(selectedOrganization, selectedOrganization === emuOrg ? 'emu' : 'ghec');
  };

  return (
    <InputAdornment aria-label={accessibleName} position="start">
      {selectable ? (
        <Select
          value={organization}
          onChange={handleOrganizationChange}
          inputProps={{ 'aria-label': 'GitHub organization' }}
          disableUnderline
        >
          <MenuItem value="AAInternal">AAInternal</MenuItem>
          {emuOrg && <MenuItem value={emuOrg}>{emuOrg} (EMU)</MenuItem>}
        </Select>
      ) : (
        <>
          {organization}
          {isEmuOrganization ? ' (EMU)' : ''} /
        </>
      )}
      {selectable && ' /'}
    </InputAdornment>
  );
};
